/**
 * smarte header drawer — toggle icon + accordion aria — Figma 99:9642
 */
(function () {
  function updateHeaderMetrics() {
    const header = document.querySelector('.section-smarte-header');
    if (!header) return;

    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-height', `${rect.height}px`);
    document.documentElement.style.setProperty('--header-offset-top', `${rect.top}px`);
  }

  function initDrawer(root) {
    const container = root.querySelector('.smarte-drawer-container');
    if (!container || container.dataset.smarteDrawerInit) return;

    container.dataset.smarteDrawerInit = 'true';

    const summary = container.querySelector('.smarte-header__menu-toggle');
    const accordions = container.querySelectorAll('.smarte-drawer__accordion');

    container.addEventListener('toggle', () => {
      const isOpen = container.hasAttribute('open');
      if (summary) {
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      if (isOpen) {
        updateHeaderMetrics();
      }
    });

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('.smarte-drawer__trigger');
      if (!trigger) return;

      accordion.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', accordion.hasAttribute('open') ? 'true' : 'false');
      });
    });
  }

  function init(root) {
    root.querySelectorAll('.smarte-header__drawer').forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
